import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "errors", "success", "errorList", "successMessage", "submitBtn"]

  connect() {
    // Listen for Turbo form submission events
    this.formTarget.addEventListener("turbo:submit-start", this.handleSubmitStart.bind(this))
    this.formTarget.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
  }

  handleSubmitStart(event) {
    this.hideMessages()
    this.setSubmittingState()
  }

  handleSubmitEnd(event) {
    const detail = event.detail

    // Reset the submit button
    this.resetSubmitButton()

    // Check if submission was successful (no errors)
    if (detail.success !== false) {
      this.closeModalAndResetForm()
    }
  }

  closeModalAndResetForm() {
    // Try clicking the close button first
    const closeButton = document.querySelector('[data-modal-hide="inquiry-modal"]');
    if (closeButton) {
      closeButton.click();
    } else {
      // Fallback: force close manually
      const modal = document.getElementById('inquiry-modal');
      if (modal) {
        modal.classList.add('hidden');
        modal.setAttribute('aria-hidden', 'true');
        modal.style.display = 'none';

        // Remove backdrop
        const backdrops = document.querySelectorAll('[modal-backdrop], .bg-gray-900, .bg-opacity-50, .fixed.inset-0');
        backdrops.forEach(backdrop => backdrop.remove());

        // Restore body scroll
        document.body.style.overflow = '';
        document.body.classList.remove('overflow-hidden');
      }
    }

    // Reset the form
    if (this.hasFormTarget) {
      this.formTarget.reset();
    }

    // Hide any error/success messages in the form
    this.hideMessages();
  }

  setSubmittingState() {
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = true
      this.submitBtnTarget.textContent = "提交中..."
    }
  }

  resetSubmitButton() {
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = false
      this.submitBtnTarget.textContent = "提交咨询"
    }
  }

  hideMessages() {
    if (this.hasErrorsTarget) {
      this.errorsTarget.classList.add('hidden')
    }
    if (this.hasSuccessTarget) {
      this.successTarget.classList.add('hidden')
    }
  }
}
